import { render } from "./CompanyManagementExpense.vue?vue&type=template&id=6da72594"
import script from "./CompanyManagementExpense.vue?vue&type=script&lang=js"
export * from "./CompanyManagementExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__